
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/connors-collective",
      function () {
        return require("private-next-pages/connors-collective/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/connors-collective"])
      });
    }
  